class CSSVariables {
  /**
   * Set CSS variable
   * @param {string} name - CSS variable name
   * @param {string} value - CSS variable value
   */
  static set(name: string, value: string) {
    document.documentElement.style.setProperty(name, value);
  }

  /**
   * Get CSS variable
   * @param {string} name - CSS variable name
   * @returns {string} CSS variable value
   */
  static get(name: string) {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
  }
}

export default CSSVariables;
